import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'
import { getSlug } from '@/core/utils.js'

export default class SilverTotem extends HObject {
  static meshes = []
  static loadRequest = false
  constructor(hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
    this.inQueue = false
  }

  loadObject () {
    let hObject = this
    SilverTotem.loadRequest = true
    BABYLON.SceneLoader.LoadAssetContainerAsync('static/assets/SilverTotem/', 'SilverTotem.babylon', window.scene).then(function (container) {
      for (let i = 0; i < container.meshes.length; i++) {
        container.meshes[i].isVisible = false
      }
      hObject.lod(container.meshes, 3000)
      container.addAllToScene()

      SilverTotem.meshes = container.meshes
    })
  }

  register () {
    this.setupWidgets()
    this.loadContentImages()
    if (SilverTotem.meshes.length) { // Se puede registrar el objeto puesto que ya se pueden crear instancias
      // Se marca que ya queda registrado, para que en un siguiente registro no se registre mas de una vez
      this.registered = true

      let newInstances = []

      for (let i = 0; i < SilverTotem.meshes.length; i++) {

        // Crea clones para los mesh que se definen como widgets (porque no pueden compartir texturas)
        if (this.getIndexWidgetByMeshName(SilverTotem.meshes[i].name) !== -1) {
          newInstances.push(SilverTotem.meshes[i].clone(SilverTotem.meshes[i].name))
          newInstances[newInstances.length - 1].isVisible = true
        }
        else { // Crea instancias para los que no requieren cambiar propiedades
          newInstances.push(SilverTotem.meshes[i].createInstance(SilverTotem.meshes[i].name))
        }
        //Asignando el padre correspondiente en newInstances según la misma relación en el arreglo original meshes
        if (SilverTotem.meshes[i].parent !== undefined) {
          newInstances[i].parent = newInstances.find(mesh => mesh.name === SilverTotem.meshes[i].parent.name)
        }
      }

      this.objectConfigurations(newInstances)

      this.afterloadSetup()
    } else {
      if (SilverTotem.loadRequest === false) { // La primera vez que se desea registrar el objeto se debe cargar desde el servidor
        this.loadObject()
      }
      // Se agrega el objeto a la cola para reintentar posteriormente
      if (!this.inQueue) { // Se agrega sólo si aún no se ha agregado a la cola
        this.inQueue = true
        window.hScene.hObjectsRegisterQueue.push(this)
      }
    }
  }

  setupWidgets () {
    let label = {}
    label.meshName = 'label'
    label.maxImages = 1
    this.addWidget(label)

    let monitor = {}
    monitor.meshName = 'monitor'
    monitor.maxImages = 10
    this.addWidget(monitor)
  }

  afterloadSetup () {
    this.setContentFirstImages()
    this.widgetControls()

  }

  widgetControls () {
    let widget = this.getWidgetByMeshName('monitor')
    let mesh = this.getMeshByName('monitor')
    this.getMeshByName('leftArrowControl').actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
      widget.currentImage--
      if(widget.currentImage < 1) {
        widget.currentImage = widget.numImages
      }
      let imageName = getSlug(`${widget.name}-${widget.currentImage}`)
      mesh.material = window.scene.getMaterialByName(imageName)
    }))
    this.getMeshByName('rightArrowControl').actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
      widget.currentImage++
      if(widget.currentImage > widget.numImages) {
        widget.currentImage = 1
      }
      let imageName = getSlug(`${widget.name}-${widget.currentImage}`)
      mesh.material = window.scene.getMaterialByName(imageName)
    }))
  }
}



// WEBPACK FOOTER //
// ./src/hobjects/SilverTotem.js